import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function HeroSection() {
  const { t } = useTranslation()

  return (
    <section className="hero-section">
      <div className="hero-content">
        <h1>{t('hero.title', 'Khám Phá Việt Nam')}</h1>
        <p>{t('hero.subtitle', 'Cùng DelyTour - Trải nghiệm du lịch tuyệt vời')}</p>
        <div className="hero-buttons">
          <Link to="/tours" className="btn-primary">
            {t('hero.viewTours', 'Xem Tours')}
          </Link>
          <Link to="/destinations" className="btn-secondary">
            {t('hero.destinations', 'Điểm Đến')}
          </Link>
        </div>
      </div>

      <style>{`
        .hero-section {
          min-height: 500px;
          background: linear-gradient(135deg, var(--color-button-gradient-from) 0%, var(--color-button-gradient-to) 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: white;
          padding: 80px 24px;
        }

        .hero-content h1 {
          font-size: 3.5rem;
          font-weight: 800;
          margin-bottom: 24px;
          animation: fadeInUp 0.8s ease-out;
        }

        .hero-content p {
          font-size: 1.5rem;
          margin-bottom: 40px;
          opacity: 0.95;
          animation: fadeInUp 0.8s ease-out 0.2s backwards;
        }

        .hero-buttons {
          display: flex;
          gap: 20px;
          justify-content: center;
          animation: fadeInUp 0.8s ease-out 0.4s backwards;
        }

        .btn-primary, .btn-secondary {
          padding: 16px 40px;
          border-radius: 12px;
          font-weight: 600;
          font-size: 1.1rem;
          text-decoration: none;
          transition: all 0.3s;
        }

        .btn-primary {
          background: white;
          color: var(--color-primary);
        }

        .btn-primary:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
          color: var(--color-primary-hover);
        }

        .btn-secondary {
          background: rgba(255, 255, 255, 0.2);
          color: white;
          border: 2px solid white;
        }

        .btn-secondary:hover {
          background: rgba(255, 255, 255, 0.3);
          transform: translateY(-3px);
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 768px) {
          .hero-content h1 {
            font-size: 2.5rem;
          }

          .hero-content p {
            font-size: 1.2rem;
          }

          .hero-buttons {
            flex-direction: column;
            align-items: center;
          }

          .btn-primary, .btn-secondary {
            width: 100%;
            max-width: 300px;
          }
        }
      `}</style>
    </section>
  )
}

